window.addEventListener('load', function() {
    if( document.URL.endsWith("#inscription-newsletter") ) {
      document.querySelector(".footer__subscription .js-popup-button.btn").click();
    }
    document.querySelector(".footer__subscription .js-popup-button.btn").addEventListener("click", function(e){
      if(document.querySelector("body").getAttribute("id") != "le-projet" ) {

        window.history.replaceState(null,null,"#inscription-newsletter")

      }
    })
})

let newsletterEmailElement = document.querySelector("#newsletter_email");
if (newsletterEmailElement) {
  newsletterEmailElement.addEventListener('change', function () {
    let newsletterEmail = newsletterEmailElement.value;
    let newsletterPopup = document.querySelector('[data-js-popup-name="newsletter_subscription"]');
    if (newsletterPopup) {
      document.querySelector('#newsletter-form [name="contact[email]"]').value = newsletterEmail;
    }});
}

let accountSubscribe = document.querySelector("#PopupAccountSubscribe");
if (accountSubscribe) {
  accountSubscribe.addEventListener('change', function () {
    let newsletterEmail = accountSubscribe.value;
    let newsletterPopup = document.querySelector('[data-js-popup-name="newsletter_subscription"]');
    if (newsletterPopup) {
      document.querySelector('#newsletter-form [name="contact[email]"]').value = newsletterEmail;
    }});
}
